import { ContractService } from "./../../../services/catalogs/ContractService";
import React from "react";
import { ContractDetail } from "../../../components/Pages/Catalogs/Contract/ContractDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateContractDto } from "../../../dtos/catalogs/contract/CreateContractDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupContract } from "../../../components/Shared/NewForms/NFLookupContract";
import ContractList from "../../../components/Pages/Catalogs/Contract/ContractList";

export const Contract: IAppEntity = {
  entityType: "catalog",
  title: "Contract",
  pluralTitle: "Contracts",
  apiUrl: "Contracts",
  apiEnum: ReferenceTypes.CatalogContract,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ContractDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ContractList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupContract, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ContractService("Contracts"),
  getEmptyModel: () => {
    const model: CreateContractDto = {
      name: "",
    };
    return model;
  },
};
